import { styled } from '../../theme'
import { MsdkStyledComponent } from '../../utils'

export const FlexLayout: MsdkStyledComponent<any> = styled('div')`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  & > * {
    min-width: 280px;
    width: 100%;
    margin: 0 8px;
    margin-bottom: 32px;
  }
`

// TODO migrate to https://mui.com/material-ui/react-stack/
